export default __webpack_public_path__ + "static/media/element5.857daaa0.svg";